import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'store';

import { types } from './types';
import { login, logout } from './thunks';

const authStore = (store: RootState) => store?.auth;

const selectIsLoggedIn = createSelector(
  [authStore],
  (store) => store?.isLoggedIn ?? false
);

const selectAuthError = createSelector([authStore], (store) => store?.error);

const selectAuthRestorePath = createSelector(
  [authStore],
  (store) => store?.path
);

const selectAuthUser = createSelector([authStore], (store) => store?.user);

const selectIsGuestUser = createSelector(
  [authStore],
  (store) => store?.isGuestUser
);

const selectAuthUserRole = createSelector(
  [authStore],
  (store) => store?.user?.role
);

export {
  login,
  types,
  logout,
  selectAuthUser,
  selectAuthError,
  selectIsLoggedIn,
  selectIsGuestUser,
  selectAuthUserRole,
  selectAuthRestorePath,
};
